import React from 'react';
import { useDispatch } from "react-redux";
import { authLogOut } from '../../redux/Slices/authDataSlice';
import { Navigate } from 'react-router-dom';

const Logout = (props) => {
  const dispatch = useDispatch();
  dispatch(authLogOut());
  localStorage.clear();

  return <Navigate to="/login" replace />;
}

export default Logout;